export default "__VITE_ASSET__Brq2P8al__"